import { render, staticRenderFns } from "./template-text.vue?vue&type=template&id=4ff09aee&scoped=true&"
import script from "./template-text.vue?vue&type=script&lang=js&"
export * from "./template-text.vue?vue&type=script&lang=js&"
import style0 from "./template-text.vue?vue&type=style&index=0&id=4ff09aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff09aee",
  null
  
)

export default component.exports